import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ReviewIdEnum } from '@app/core';
import { Review } from '@app/core/interfaces';
import { ProductIdNameService } from '@app/core/services/product-id-name.service';
import * as reviewsActions from '@app/store/actions/reviews.actions';
import * as fromRoot from '@app/store/app.reducer';
import { ReviewsService } from '@app/store/effects/reviews.service';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
    selector: 'ins-review-list-container',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <ins-review-list
            [reviews]="reviews$ | async" [totalPages]="totalPages$ | async" (pageSelected)="onPageSelected($event)">
        </ins-review-list>
    `,
})
export class ReviewListContainer implements OnInit {
    @Input() reviewId: ReviewIdEnum = ReviewIdEnum.InShared;

    public readonly reviews$: Observable<Review[]> = this.reviewsService.reviews$;
    public readonly totalPages$ = this.store.pipe(select(fromRoot.getTotalReviewPages));

    constructor(
        private reviewsService: ReviewsService,
        private store: Store<fromRoot.State>,
    ) { }

    ngOnInit(): void {
        const productName = ProductIdNameService.getProductNameByReviewId(this.reviewId);
        this.store.dispatch(new reviewsActions.SetSelectedProductName({product_id: productName}));
    }

    public onPageSelected(pageNumber: number): void {
        if (pageNumber) {
            this.store.dispatch(new reviewsActions.SetSelectedReviewPageNumber({ pageNumber }));
        }
    }
}
